import styled from 'styled-components';
import { Box } from '@app/src/components/Box';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;

  @media (min-width: 480px) {
    flex-wrap: nowrap;
    flex-direction: row;
  }
`;

export const Content = styled.div`
  width: 100%;
  z-index: 0;

  @media (min-width: 480px) {
    width: calc(100% - 80px);
  }
`;

export const ContainerServices = styled.div`
  background: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ContentFormServices = styled.div`
  background: white;
  padding: 40px;
  border-radius: 8px;
  width: 400px;
`;
